module.exports = __webpack_public_path__ + "static/media/SUBDRIVEQUICKPAK.9872f4d2.pdf";